import styled from 'styled-components'

export const StyledSeparator = {
  Container: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px 0;
  `,
  TextBlock: styled.p`
    padding: 0 10px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    text-transform: uppercase;
    color: #898b95;
  `,
  Line: styled.div`
    flex-grow: 1;
    height: 1px;
    background-color: #4e5160;
  `,
}
